export function getFdesCalculatorApi(fdes) {
  const hasApsiviCalculator = !!fdes?.calculus?.apsivi?.modelFile;
  const hasGoogleCalculator = !!fdes?.calculus?.googleDrive?.sheetId;

  if (hasApsiviCalculator) {
    return "apsivi";
  }

  if (hasGoogleCalculator) {
    return "google";
  }

  return undefined;
}
